module.exports = "/_next/static/images/sticky-desktop-5e69e1e363b4e5be83c6e258bb847989.svg";